import { Injectable, Inject } from '@angular/core';
import * as Immutable from "immutable";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Unsubscribe } from "redux";

import { ApiResponse } from "../../models/responses";
import { HttpService } from "../../../../shared/providers"
import { ConfDataRequest } from "../../models/requests/confDataRequest";
import { ConfReportRequest } from "../../models/requests/confReportRequest";
import { ConfCodeRequest } from "../../models/requests/confCodeRequest";
import { ConfGraphicsRequest } from "../../models/requests/confGraphicsRequest";
import { ApiResponseBuilder } from "../apiResponseBuilder";
import { ConfAttachmentRequest, ConfDocumentRequest } from "../../models";
import { GlobalDataStore } from "../globalData";

// MOVE THIS CLASS TO PAGES/SHARED/PROVIDERS

@Injectable()
export class ConfDataController {

  public configuratorControllerUrl = 'api/configurator';

  constructor(
    @Inject(HttpService) public httpService: HttpService,
    public apiResponseBuilder: ApiResponseBuilder,
    public globalDataStore: GlobalDataStore
  ) { }

  public buildResponseObject = map((response, index) => this.apiResponseBuilder.build(response));

  public getConfigurationData(requestModel: ConfDataRequest): Observable<ApiResponse> {
    return this.httpService.get(this.configuratorControllerUrl, requestModel).pipe(this.buildResponseObject);
  }
  
  public postConfigurationData(requestModel: ConfDataRequest): Observable<ApiResponse> {
    return this.httpService.post(this.configuratorControllerUrl, requestModel).pipe(this.buildResponseObject);
  }
  
  public getConfigurationReportUrl(model: ConfReportRequest ) {
    return this.httpService.createUrl(`${this.configuratorControllerUrl}/report`, model);
  }

  public getConfigurationCodeUrl(model: ConfCodeRequest) {
    return this.httpService.createUrl(`${this.configuratorControllerUrl}/code`, model);
  }

  public getConfigurationAttachmentUrl(model: ConfAttachmentRequest) {
    return this.httpService.createUrl(`${this.configuratorControllerUrl}/attachment`, model);
  }

  public getConfigurationDocumentUrl(model: ConfDocumentRequest) {
    return this.httpService.createUrl(`${this.configuratorControllerUrl}/document`, model);
  }

  public getConfigurationGraphicUrl(model: ConfGraphicsRequest) {
    return this.httpService.createUrl(`${this.configuratorControllerUrl}/graphics`, model);
  }

  public getConfigurationGraphicViewerUrl(model: ConfGraphicsRequest) {

    let baseUrl = this.globalDataStore.getGlobalData().webSettings.baseUrl;

    let queryString = this.httpService.createUrl(`${baseUrl}/${this.configuratorControllerUrl}/graphics`, model);

    return `${baseUrl}/contents/svg-viewer.html?${queryString}`;
  }
}